export const LatestColourConfig = {
  green1: '#008000',
  green2: '#004c00',
  green3: '#002600',
  green4: '#000000',
  green5: '#198c19',
  green6: '#4ca64c',
  green7: '#7fbf7f',
  green8: '#b2d8b2',
  green9: '#e5f2e5',
  red1: '#ff0000',
  red2: '#cc0000',
  red3: '#990000',
  red4: '#660000',
  red5: '#190000',
  red6: '#ff4c4c',
  red7: '#ff7f7f',
  red8: '#ffb2b2',
  red9: '#ffe5e5',
  blue1: '#0000ff',
  blue2: '#0000cc',
  blue3: '#00007f',
  blue4: '#000033',
  blue5: '#000000',
  blue6: '#3232ff',
  blue7: '#6666ff',
  blue8: '#b2b2ff',
  blue9: '#e5e5ff',
};

export const ColourConfig = {
  red: '#ff4b55',
  new: '#00BFFF',
  green: '#00c673',
  amber: '#ff9e00',
  grey: '#86A0C2',
  black: '#000000',
  pink: '#ff0099',
  purple: '#aa00ff',
  orange: '#ff9100',
  brown: '#7a4900',
  olive: '#808000',
  aqua: '#00FFFF',
  teal: '#008080',
  yellow: '#FFFF00',
  maroon: '#8a0000',
  lime: '#00FF00',
  fuchsia: '#FF00FF',
  navy: '#000080',
  default: '#00BFFF',
  lightcoral: '#F08080',
  darksalmon: '#E9967A',
  mediumvioletred: '#C71585',
  palevioletred: '#DB7093',
  khaki: '#F0E68C',
  darkslategray: '#2F4F4F',
  tan: '#D2B48C',
  goldenrod: '#B8860B',
  ...LatestColourConfig,
};

export const ColourConfigWithClass = {
  red: 'Poor',
  new: 'New',
  green: 'High',
  amber: 'Moderate',
};
export const orderList = ['red', 'amber', 'green', 'new'];

export const merchantIconImgConfig = {
  done: 'done.svg',
  pending: 'pending.svg',
  urgentSupport: 'urgent-support.svg',
};

export const TeamColorConfig = {
  businesshead: '#00FF00',
  hubhead: '#FF00FF',
  regionalhead: '#e0ffff',
  statehead: '#0047ab',
  cityhead: '#B3325D',
  asm: '#FED533',
  kam: '#F495E3',
  tl: '#223368',
  'sr.fse': '#00B8F5',
  groupleader: '#56CCDE',
  fse: '#FF9D00',
  outofzone: '#FD5154',
};
